import { CheckboxList } from "@monsterindia/global-ui-components";
import { FC, memo } from "react";
import { Controller } from "react-hook-form";

import { ErrorText } from "../../apop/common/ErrorText";
import { CheckBoxControllerProps } from "./checkboxController.types";

const CheckBoxController: FC<CheckBoxControllerProps> = ({
  name,
  control,
  options,
  size = "large",
  errorMessage,
  isDefaultChecked,
  onChange,
  isRequired,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={isRequired ? { required: "This field is required" } : undefined}
      render={({ field }) => {
        return (
          <div className="l1-flex l1-flex-row l1-gap-1">
            <CheckboxList
              size={size}
              options={options}
              defaultChecked={isDefaultChecked ? [name] : []}
              eventChangeHandler={({ values }: { values: string[] }) => {
                if (values.length > 0 && values.includes(name)) {
                  field.onChange(true);
                  onChange && onChange(true);
                } else {
                  field.onChange(false);
                  onChange && onChange(false);
                }
              }}
            />
            {isRequired && <span className="l1-mt-1 l1-text-red-500">*</span>}
            {errorMessage ? <ErrorText text={errorMessage} /> : null}
          </div>
        );
      }}
    />
  );
};

export default memo(CheckBoxController);
